module.exports = __webpack_public_path__ + "static/20th-0dabf5e43012df98eaaba311dc4b4869.png";